import { Component, Input, OnChanges, OnInit, SimpleChanges, } from '@angular/core';
import { NOTIFICATION_TYPE, NotificationEvent } from '../../services/NotificationService';

@Component({
  selector: 'app-notification-block',
  templateUrl: './notification-block.component.html',
  styleUrls: ['./notification-block.component.css']
})
export class NotificationBlockComponent implements OnInit, OnChanges {
  @Input()
  notification: NotificationEvent;

  showNotifications = false;
  currentNotification: NotificationEvent;

  constructor() { }

  ngOnInit(): void { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.notification.currentValue && changes.notification.currentValue.type !== NOTIFICATION_TYPE.HIDDEN) {
      this.showNotifications = true;
      this.currentNotification = changes.notification.currentValue;
    } else {
      this.showNotifications = false;
      this.clearNotification();
    }
  }

  private clearNotification(): void {
    this.currentNotification = {
      type: NOTIFICATION_TYPE.HIDDEN,
    };
  }
}
